import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccueilComponent } from './principal/accueil/accueil.component';
import { InterventionsComponent } from './principal/interventions/interventions.component';
import { ListeRuchersComponent } from './principal/interventions/liste-ruchers/liste-ruchers.component';
import { AdminComponent } from './admin/admin.component';
import { PrincipalComponent } from './principal/principal.component';
import { InterventionComponent } from './principal/interventions/intervention/intervention.component';
import { DetailInterventionComponent } from './principal/interventions/detail-intervention/detail-intervention.component';
import { ListeInterventionsComponent } from './principal/interventions/liste-interventions/liste-interventions.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  { path: '', component: PrincipalComponent,
      children: [
        { path: 'accueil', component: AccueilComponent },
        { path: 'interventions', component: InterventionsComponent, data: { preload: true },
          children: [
            { path: '', component: ListeRuchersComponent},
            { path: 'inter/:id', component: InterventionComponent,
              children: [
                { path: 'listeinter/:id', component: ListeInterventionsComponent },
                { path: 'detailinter/:id', component: DetailInterventionComponent }
              ]
            }]
        }
      ]
  },
  { path: 'admin', loadChildren: './admin/admin.module#AdminModule' }//,
  //{ path: '', redirectTo: '/accueil/accueil', pathMatch: 'full' }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts